import { useQuery } from '@tanstack/react-query';
import { fetchIdentidade } from '../data/api';

export function useLogo() {
  const { data } = useQuery({
    queryKey: ['identidade'],
    queryFn: fetchIdentidade,
    placeholderData: { logoUrl: '/logo.png' },
    staleTime: 60000,
  });
  return data?.logoUrl || '/logo.png';
}
